import type { BridgeDiagnostic } from '@shared/bridge-contract';
import { getDesktopBridgeErrorMessage } from '@renderer/lib/desktop-api';

function getBridgeDiagnosticTitle(status: BridgeDiagnostic['status']): string {
  switch (status) {
    case 'browser':
      return 'Porneste bridge-ul local';
    case 'preload-missing':
      return 'Bridge desktop indisponibil';
    case 'api-missing':
      return 'API desktop indisponibil';
    case 'api-incomplete':
      return 'Bridge desktop incomplet';
    case 'api-stale':
      return 'Bridge desktop invechit';
    case 'version-mismatch':
      return 'Versiuni desktop nealiniate';
    case 'ready':
      return 'Bridge desktop activ';
  }
}

function formatList(items: string[]): string {
  if (items.length === 0) {
    return 'Nimic lipsa';
  }

  return items.slice(0, 12).join(', ') + (items.length > 12 ? ` si inca ${items.length - 12}` : '');
}

export function BridgeDiagnosticScreen({ diagnostic }: { diagnostic: BridgeDiagnostic }): JSX.Element {
  const description = getDesktopBridgeErrorMessage(diagnostic);

  return (
    <main className="av-bridge-diagnostic">
      <section className="av-bridge-diagnostic__panel" aria-labelledby="bridge-diagnostic-title">
        <p className="av-bridge-diagnostic__eyebrow">Diagnostic pornire</p>
        <h1 id="bridge-diagnostic-title">{getBridgeDiagnosticTitle(diagnostic.status)}</h1>
        <p>{description}</p>

        <dl className="av-bridge-diagnostic__facts">
          <div>
            <dt>Context</dt>
            <dd>{diagnostic.isElectron ? 'Electron' : 'Browser'}</dd>
          </div>
          <div>
            <dt>API preload</dt>
            <dd>{diagnostic.hasApi ? 'prezent' : 'lipsa'}</dd>
          </div>
          <div>
            <dt>Contract</dt>
            <dd>{diagnostic.hasBridge ? diagnostic.actualVersion ?? 'necunoscut' : 'lipsa'}</dd>
          </div>
          <div>
            <dt>Renderer</dt>
            <dd>{diagnostic.expectedVersion}</dd>
          </div>
        </dl>

        {diagnostic.missingDomains.length > 0 || diagnostic.missingMethods.length > 0 ? (
          <div className="av-bridge-diagnostic__details">
            <strong>Elemente lipsa</strong>
            <span>{formatList([...diagnostic.missingDomains, ...diagnostic.missingMethods])}</span>
          </div>
        ) : null}

        <div className="av-bridge-diagnostic__actions">
          <button type="button" onClick={() => window.location.reload()}>
            Reincarca
          </button>
        </div>

        <p className="av-bridge-diagnostic__hint">
          In browser, datele reale vin prin procesul Electron pornit cu npm run electron:dev. Daca problema este preload-ul,
          reincarcarea paginii nu este suficienta; reconstruieste si reporneste aplicatia.
        </p>
      </section>
    </main>
  );
}
